import authRules from '../authRules.js';

const addAssignmentViewAssignmentStatus = (user) => {
  const { assignmentStatus } = user.securityLevels;
  if (assignmentStatus >= authRules.addAssignmentViewAssignmentStatus.assignmentStatus) {
    return true;
  } else {
    return false;
  }
}

export default addAssignmentViewAssignmentStatus;
